export const Logo = ({ className = "", ringColor = "#0A1A4A" }) => (
  <svg viewBox="0 0 104 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
    <g stroke={ringColor} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none">
      {/* Φ — circle */}
      <circle cx="46" cy="50" r="40" />
      {/* shared vertical spine (Φ stem + Ε spine) */}
      <line x1="57" y1="12" x2="57" y2="88" />
      {/* Ε — three horizontal bars */}
      <line x1="57" y1="14" x2="98" y2="14" />
      <line x1="57" y1="50" x2="90" y2="50" />
      <line x1="57" y1="86" x2="98" y2="86" />
    </g>
  </svg>
);
